import { utf8Decode } from '@/plugins/globals.plugin'
import * as tacRCode from '@/assets/scripts/tac_rcode'

export const state = {
  list: []
}

export const getters = {
  getErrorObj: () => (errBody) => {
    const errObj = {
      time: new Date().getTime(),
      code: null,
      hint: null,
      pt: {
        title: null,
        message: null
      },
      en: {
        title: null,
        message: null
      }
    }

    if (errBody && errBody.rc) {
      const tac = tacRCode.RCODE_INFO[errBody.rc]
      const hexString = errBody.rc.toString(16).slice(3)
      errObj.code = parseInt(hexString, 16)
      errObj.hint = tac[tacRCode.RCODE_hint][0]
      errObj.pt = {
        title: tac[tacRCode.RCODE_pt_BR][tacRCode.RCODE_sd],
        message: utf8Decode(atob(tac[tacRCode.RCODE_pt_BR][tacRCode.RCODE_ld]))
      }
      errObj.en = {
        title: tac[tacRCode.RCODE_en_US][tacRCode.RCODE_sd],
        message: utf8Decode(atob(tac[tacRCode.RCODE_en_US][tacRCode.RCODE_ld]))
      }
    } else {
      errObj.code = null
      errObj.hint = null
      errObj.pt = {
        title: errBody,
        message: errBody
      }
      errObj.en = {
        title: errBody,
        message: errBody
      }
    }
    return errObj
  }
}

export const mutations = {
  SET_ITEM_IN_LIST (state, payload = {}) {
    state.list.unshift(payload)
  },
  CLEAR (state) {
    state.list = []
  }
}

export const actions = {
  setError ({ dispatch, getters, commit }, { error }) {
    if (error.rc === tacRCode.ERR_ACCESS_DENIED) {
      dispatch('hsm/getProbe', {}, { root: true }).catch(err => {
        if (err.rc === tacRCode.ERR_ACCESS_DENIED) {
          dispatch('auth/doLogout', {}, { root: true })
        }
      })
    }
    if (error.rc === tacRCode.ERR_INVALID_KEY) {
      dispatch('auth/doLogout', {}, { root: true })
    }
    const errObj = getters.getErrorObj(error)

    commit('SET_ITEM_IN_LIST', errObj)
  },
  clearError ({ commit }) {
    commit('CLEAR')
  }
}
